import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders,HttpParams } from '@angular/common/http';


import { Observable, of, throwError } from 'rxjs';
import { catchError, last, map, tap } from 'rxjs/operators';

// URL to web api
const baseApiUrl = '';
const httpOptions = {
  headers: new HttpHeaders({ 'Content-Type': 'application/json' })
}

@Injectable({
  providedIn: 'root'
})
export class CustomerPasswordService {
  constructor(private http: HttpClient) {}

  getBasicCustDetails(custId : any): Observable<any> {
    const get_url = baseApiUrl + 'subscriber/getBasicCustDetails/' + custId;
    return this.http.get<any>(get_url,
      { headers: httpOptions.headers }).pipe(
        map(res => res),
        catchError((error: any) => {
          return throwError(error);
        })
      );
  }

  resetCustPassword(id : any) : Observable<any> {
      const post_url = baseApiUrl + 'subscriber/customer/resetPassword/';
      return this.http.post<any>(post_url, id, httpOptions)
      .pipe(map(res => res),
      catchError((error: any) => {
        return throwError(error);
      })
      );
    }
  
    updateCustPassword(custPassword_data : any) : Observable<any> {
      const post_url = baseApiUrl + 'subscriber/customer/updatePassword/';
      return this.http.post<any>(post_url, custPassword_data, httpOptions)
      .pipe(map(res => res),
      catchError((error: any) => {
        return throwError(error);
      })
      );
    }
}